import React from 'react';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';
import Base from './Base'

export class NavMenu extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            menuOpen: 1
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return contents;
    }
    toggleMenu() {
        if (this.state.menuOpen == 1) this.setState({ menuOpen: 0 });
        else this.setState({ menuOpen: 1 });
    }
    renderForm() {
        return <div className={"nk-sidebar nk-sidebar-fixed is-dark " + (this.state.menuOpen == 1 ? "" : "is-compact")} id="sideBarMenu" data-content="sidebarMenu">
            <div className="nk-sidebar-element nk-sidebar-head">
                <div className="nk-menu-trigger" onClick={e => this.toggleMenu()}>
                    <a className="nk-nav-toggle nk-quick-nav-icon d-xl-none" data-target="sidebarMenu"><em className="icon ni ni-arrow-left"></em></a>
                    <a className="nk-nav-compact nk-quick-nav-icon d-none d-xl-inline-flex" data-target="sidebarMenu"><em className="icon ni ni-menu"></em></a>
                </div>
                <div className="nk-sidebar-brand">
                    <a href="/" className="logo-link nk-sidebar-logo">
                        <img className="logo-light logo-img" src="/assets/images/testLogo.png" alt="" style={{ "min-height": "60px" }} />
                        <img className="logo-dark logo-img" src="/assets/images/testLogo.png" alt="" style={{ "min-height": "60px" }} />
                    </a>
                </div>
            </div>
            <div className="nk-sidebar-element nk-sidebar-body">
                <div className="nk-sidebar-content">
                    <div className="nk-sidebar-menu" data-simplebar>
                        <ul className="nk-menu">
                            <li className="nk-menu-item">
                                <Link to="/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-home"></em></span>
                                    <span className="nk-menu-text">داشبرد</span>
                                </Link>
                            </li>
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-heading">
                                <span className="textnew">مدیریت</span>
                            </li>}
                            {this.state.data.global.user.role === 1 && <li className="nk-menu-item">
                                <Link to="/users/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-users"></em></span>
                                    <span className="nk-menu-text">کاربران</span>
                                </Link>
                            </li>}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/legalobligationtemplates/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-calendar"></em></span>
                                        <span className="nk-menu-text">تکالیف قانونی</span>
                                    </Link>
                                </li>
                            )}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/holidays/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-calendar"></em></span>
                                        <span className="nk-menu-text">تعطیلات</span>
                                    </Link>
                                </li>
                            )}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/reports/timesheet/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-clock"></em></span>
                                        <span className="nk-menu-text">تایم‌شیت</span>
                                    </Link>
                                </li>
                            )}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/reports/contract-performance/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">عملکرد قراردادها</span>
                                    </Link>
                                </li>
                            )}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/reports/daily-work/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">گزارش کار روزانه</span>
                                    </Link>
                                </li>
                            )}

                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/reports/productivity/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                        <span className="nk-menu-text">گزارش بهره‌وری</span>
                                    </Link>
                                </li>
                            )}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/audit-logs/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-list"></em></span>
                                        <span className="nk-menu-text">لاگ فعالیت‌ها</span>
                                    </Link>
                                </li>
                            )}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/advanced-dashboard/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-dashboard-fill"></em></span>
                                        <span className="nk-menu-text">داشبورد مدیریت</span>
                                    </Link>
                                </li>
                            )}
                            <li className="nk-menu-heading">
                                <span className="textnew">اطلاعات پایه</span>
                            </li>
                            <li className="nk-menu-item">
                                <Link to="/calendar/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-calendar"></em></span>
                                    <span className="nk-menu-text">تقویم</span>
                                </Link>
                            </li>
                            <li className="nk-menu-item">
                                <Link to="/customers/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-building"></em></span>
                                    <span className="nk-menu-text">پرونده مشتریان</span>
                                </Link>
                            </li>
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/contracts/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-users"></em></span>
                                        <span className="nk-menu-text">قراردادهای مشتریان</span>
                                    </Link>
                                </li>
                            )}
                            {this.state.data.global.user.role === 1 && (
                                <li className="nk-menu-item">
                                    <Link to="/services/" className="nk-menu-link">
                                        <span className="nk-menu-icon"><em className="icon ni ni-package-fill"></em></span>
                                        <span className="nk-menu-text">تعریف خدمات</span>
                                    </Link>
                                </li>
                            )}

                            <li className="nk-menu-item">
                                <Link to="/tasks/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-package-fill"></em></span>
                                    <span className="nk-menu-text">وظایف</span>
                                </Link>
                            </li>
                            
                          
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    }
}
